export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    align: 'center',
    fixed: 'right',
    width: 140,
    showHeaderOverflow: true,
    showOverflow: true,
    slots: {
      default: 'opt',
    },
  },
  {
    title: that.$l('table_label_mrpPurchaseStockInNo') || '采购入库单编号',
    field: 'mrpPurchaseStockInNo',
    headerAlign: 'center',
    minWidth: 150,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_purchaseStockInStatus') || '采购入库单状态',
    field: 'purchaseStockInStatus',
    headerAlign: 'center',
    minWidth: 120,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    slots: { default: 'status' }
  },
  {
    title: that.$l('table_label_warehouse_name') || '入库仓库',
    field: 'warehouseName',
    headerAlign: 'center',
    minWidth: 150,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_stockInDate') || '入库日期',
    field: 'stockInDate',
    headerAlign: 'center',
    minWidth: 150,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.purchase_form_label_scmName') || '供应商',
    field: 'scmName',
    headerAlign: 'center',
    minWidth: 150,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_buyerName') || '采购人员',
    field: 'buyerName',
    headerAlign: 'center',
    minWidth: 150,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.order_form_label_orderNo') || '订单编号',
    field: 'orderNo',
    headerAlign: 'center',
    minWidth: 150,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_contactMemo') || '备注',
    field: 'remark',
    headerAlign: 'center',
    minWidth: 200,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.creator') || "创建人",
    width: 170,
    headerAlign: "center",
    align: "center",
    showHeaderOverflow: true,
    slots: {
      default: "createInfo",
    },
  },
  {
    title: that.$l('INDEX.table_label_modified_by') || "修改人",
    width: 170,
    headerAlign: "center",
    align: "center",
    showHeaderOverflow: true,
    slots: { default: "modifyInfo" },
  },

]
